// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_erQ","col":"styles_col__2b6dq"};